import { INavData } from '@coreui/angular-pro';
import { UserRole } from '../../authentication/model';

export interface IExtendedNavData extends INavData {
  roles?: UserRole[];
  requireQueryParams?: { [key: string]: string };
}

export const navItems: IExtendedNavData[] = [
  {
    name: 'Dashboard',
    url: '/secure/dashboard',
    iconComponent: { name: 'cil-speedometer' },
    roles: [UserRole.Any]
  },

  {
    name: 'My Loads',
    url: '/secure/spot-dispatch/driver/my-loads',
    iconComponent: { name: 'cil-truck' },
    roles: [UserRole.DriverDispatch]
  },

  {
    name: 'Time Tracker',
    url: '/secure/timesheets/time-tracker',
    iconComponent: { name: 'cil-clock' },
    roles: [UserRole.TimeTracker]
  },

  {
    name: 'Payroll',
    url: '/secure/payments/payrolls',
    iconComponent: { name: 'cil-money' },
    roles: [UserRole.ManagerAll, UserRole.Payroll]
  },
  {
    name: 'Schedule',
    url: '/secure/schedule/weekly-schedules',
    iconComponent: { name: 'cil-calendar' },
    roles: [UserRole.ManagerAll, UserRole.Schedule]
  },
  {
    name: $localize`Notifications`,
    url: '/secure/customer-notifications',
    iconComponent: { name: 'cil-bell' },
    roles: [UserRole.ManagerAll, UserRole.Ivmr]
  },
  {
    name: 'Spot Dispatch',
    url: '/secure/spot-dispatch/dashboard',
    iconComponent: { name: 'cil-truck' },
    roles: [UserRole.Dispatch]
  },
  {
    title: true,
    name: 'Reports',
    roles: [UserRole.ManagerAll, UserRole.Maintenance, UserRole.Ivmr, UserRole.Fuel, UserRole.Payroll, UserRole.Schedule]
  },
  {
    name: 'MMR reports',
    url: '/secure/ivmr/mmr',
    iconComponent: { name: 'cil-graph' },
    roles: [UserRole.ManagerAll, UserRole.Ivmr]
  },
  {
    name: 'State Miles Report',
    url: '/secure/ivmr/state-miles-report',
    iconComponent: { name: 'cil-graph' },
    roles: [UserRole.ManagerAll, UserRole.Ivmr]
  },
  {
    name: 'Timesheet Report',
    url: '/secure/timesheets/driver-timesheet',
    iconComponent: { name: 'cil-graph' },
    roles: [UserRole.ManagerAll, UserRole.Payroll]
  },
  {
    name: `Geofence Trips`,
    url: '/secure/reports/geofence-trips',
    iconComponent: { name: 'cil-map' },
    roles: [UserRole.ManagerAll, UserRole.Ivmr]
  },
  {
    name: `Fuel Report`,
    url: '/secure/reports/fuel',
    iconComponent: { name: 'cil-bar-chart' },
    roles: [UserRole.ManagerAll, UserRole.Fuel]
  },
  {
    name: 'DEF Report',
    url: '/secure/reports/def',
    iconComponent: { name: 'cil-bar-chart' },
    roles: [UserRole.ManagerAll, UserRole.Fuel]
  },
  {
    name: 'Profit & Loss',
    url: '/secure/reports/profit-and-loss',
    iconComponent: { name: 'cil-bar-chart' },
    roles: [UserRole.ManagerAll]
  },
  {
    name: 'Vehicle Maintenance',
    url: '/secure/reports/vehicle-maintenance',
    iconComponent: { name: 'cil-bar-chart' },
    roles: [UserRole.ManagerAll, UserRole.Ivmr, UserRole.Maintenance]
  },
  {
    name: 'Settlements',
    url: '/secure/reports/fedex-settlements',
    iconComponent: { name: 'cil-file' },
    badge: {
      color: 'info',
      text: 'NEW'
    },
    roles: [UserRole.ManagerAll, UserRole.Ivmr, UserRole.Payroll]
  },
  {
    name: 'Business Performance',
    url: '/secure/reports/bi-reports/business-performance',
    iconComponent: { name: 'cil-bar-chart' },
    badge: {
      color: 'info',
      text: 'NEW'
    },
    roles: [UserRole.DemoAdmin]
  }
  
];